registerComponent("modals/modal-videos-youtube", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O player do YouTube em modal, aberto pelos `[data-play-ytb-modal="<id>"]` da
 * página (`pages/search` hoje; `sections/slider-videos` quando tiver call site).
 *
 * ── O que mudou, e por quê (sub-lote 5d) ────────────────────────────────────
 *
 * Em 2020 o modal dependia do `vendor/luego/Player-ytb.js`, que baixava a IFrame
 * API do YouTube (~769 KiB) no `requestIdleCallback` de TODA página que o
 * renderiza — cinco das 22 —, criava um `YT.Player` vazio e trocava o vídeo com
 * `loadVideoById`. O programa não porta o `Player` (decisão 16) e a receita
 * manda o padrão do modal do site novo: o `<iframe>` nasce NO CLIQUE, com o
 * `src` do vídeo pedido (`youtube-nocookie`, `autoplay=1`, `enablejsapi=1` e os
 * `playerVars` de 2020), e é removido no fechar. Zero requisições a
 * `youtube.com` antes de alguém pedir um vídeo — é um dos portões da fase.
 *
 * Os eventos `video-sadia.playing/paused/ended/progress` que o `Player`
 * disparava em `$(document)` DEIXAM DE EXISTIR: não há ouvinte deles em lugar
 * nenhum do repositório, e um ouvinte fora dele (GTM) teria de ser jQuery — que
 * saiu do bundle. Registrado para a checagem 4 do GTM (Fase 9). Com eles sai o
 * `toSpinal` do título, que só servia para nomeá-los; `data-title-video`
 * continua no markup e não é lido.
 *
 * TweenMax virou CSS: `.is-visivel`, `.is-entrando`, `.is-aberto` e `.is-saindo`
 * em `_modal-videos-youtube.less`. `body.modal-opened`, `data-modal-format` (a
 * classe `vert` no wrapper), o Escape e o botão de fechar ficam como eram.
 *
 * A escuta do clique é por delegação em `document`, não por `$btnplay.on` nos
 * botões que existiam no boot: o que entrar depois também abre.
 *
 * Os eventos `modal:open`/`modal:close` no próprio elemento continuam (ninguém
 * os dispara hoje); `modal:open` é um `CustomEvent` com
 * `detail: { videoId, formato }`.
 */

const wrapper = component.querySelector('.modal-videos-wrapper');
const caixaDoPlayer = component.querySelector('.player');
const botaoFechar = component.querySelector('.btn-close');

let aberto = false;
let temporizador = null;

function limparTemporizador() {
    clearTimeout(temporizador);
    temporizador = null;
}

/**
 * O `<iframe>` do vídeo, com os `playerVars` que o `Player-ytb.js` passava
 * (`rel`, `iv_load_policy`, `playsinline`) mais `autoplay` e `enablejsapi`.
 *
 * @param {string} videoId
 * @returns {HTMLIFrameElement}
 */
function criarIframe(videoId) {
    const iframe = document.createElement('iframe');
    const parametros = new URLSearchParams({
        autoplay: '1',
        enablejsapi: '1',
        rel: '0',
        iv_load_policy: '3',
        playsinline: '1',
    });

    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${parametros}`;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.title = 'YouTube video player';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');

    return iframe;
}

function abrir(videoId, formato) {
    if (!videoId || !caixaDoPlayer) {
        return;
    }

    limparTemporizador();

    // O `data-modal-format` de 2020: a classe entra quando há formato e só
    // `vert` sai quando não há — à letra.
    if (wrapper) {
        if (formato) {
            wrapper.classList.add(formato);
        } else {
            wrapper.classList.remove('vert');
        }
    }

    caixaDoPlayer.textContent = '';
    caixaDoPlayer.append(criarIframe(videoId));

    aberto = true;
    document.body.classList.add('modal-opened');

    component.classList.remove('is-saindo', 'is-aberto');
    component.classList.add('is-visivel', 'is-entrando');

    const entrar = () => {
        component.classList.remove('is-entrando');
        component.classList.add('is-aberto');
    };

    // Dois quadros para o "antes" ser pintado; o setTimeout é a rede de
    // segurança da aba em segundo plano (padrão de Asa.revelar).
    requestAnimationFrame(() => requestAnimationFrame(entrar));
    temporizador = setTimeout(entrar, Asa.ESPERA_MAXIMA);
}

function terminarDeFechar() {
    limparTemporizador();
    component.removeEventListener('transitionend', aoTerminarTransicao);
    component.classList.remove('is-visivel', 'is-saindo', 'is-aberto', 'is-entrando');

    // Remover o iframe é o que para o vídeo: não há `pauseVideo` a chamar num
    // player que deixa de existir. É também o que fecha a conexão com o YouTube.
    if (caixaDoPlayer) {
        caixaDoPlayer.textContent = '';
    }
}

/** Só o `transform` do próprio modal conta — o do botão de fechar sobe também. */
function aoTerminarTransicao(evento) {
    if (evento.target === component && evento.propertyName === 'transform') {
        terminarDeFechar();
    }
}

function fechar() {
    if (!aberto) {
        return;
    }

    aberto = false;
    limparTemporizador();
    document.body.classList.remove('modal-opened');

    component.classList.remove('is-aberto', 'is-entrando');
    component.classList.add('is-saindo');

    // Sem transição (quem pediu menos movimento) não há `transitionend`.
    if (!Asa.movimentoPermitido()) {
        terminarDeFechar();

        return;
    }

    component.addEventListener('transitionend', aoTerminarTransicao);
    temporizador = setTimeout(terminarDeFechar, Asa.ESPERA_MAXIMA);
}

component.addEventListener('modal:open', /** @param {CustomEvent} evento */ function (evento) {
    const detalhe = evento.detail || {};

    abrir(detalhe.videoId, detalhe.formato);
});

component.addEventListener('modal:close', fechar);

if (botaoFechar) {
    botaoFechar.addEventListener('click', fechar);
}

document.addEventListener('click', function (evento) {
    const alvo = evento.target instanceof Element ? evento.target.closest('[data-play-ytb-modal]') : null;

    if (!alvo) {
        return;
    }

    // Tagueamento (plano v3.1): o vídeo que o corpo do post mandou abrir.
    Asa.track('video_open', { target_id: alvo.getAttribute('data-play-ytb-modal'), target_name: alvo.getAttribute('data-title-video'), origin: 'article_body' });
    Asa.track('modal_open', { modal_name: 'video_youtube', origin: 'article_body', method: 'click' });

    abrir(alvo.getAttribute('data-play-ytb-modal'), alvo.getAttribute('data-modal-format'));
});

document.addEventListener('keyup', function (evento) {
    if (aberto && evento.key === 'Escape') {
        fechar();
    }
});

});
